import { useMutation } from "urql";

import { ImportCustomerDocument } from "../../../graphql/generated.ts";

export function useImportCustomer() {
  return useMutation(ImportCustomerDocument);
}
